import { Stack, Flex, Text, VStack, useBreakpointValue } from '@chakra-ui/react';
import React from 'react';

export default function WithBackgroundImage({title, backgroundImage, cta}) {
  return (
    <Flex
      w={'full'}
      backgroundImage={backgroundImage}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat">
      <VStack
        w={'full'}
        h={'500px'}
        justify={'center'}
        px={useBreakpointValue({ base: 4, md: 8 })}
        bgGradient={'linear(to-r, blackAlpha.600, transparent)'}>
        <Stack maxW="3xl" align="center" spacing={6}>
          <Text
            justify="center"
            color="white"
            whiteSpace={'pre-line'}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={useBreakpointValue({ base: '3xl', md: '4xl' })}
            fontFamily={'GerTT'}>
            {title}
          </Text>
          {cta}
        </Stack>
      </VStack>
    </Flex>
  );
}
